import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { selectors as AuthSelectors } from 'data/auth'
import { selectors as ConfigSelectors } from 'data/config'
import { closeActiveModal } from 'data/ui/actions'
import FilesApi from 'remote/files'

import {
  createInfoToasterMessage,
  createErrorToasterMessage,
} from 'data/ui/actions'

class ImportFromGoogleDrive extends React.Component {
  static propTypes = {
    accessToken: PropTypes.string.isRequired,
    googleProjectId: PropTypes.string.isRequired,
    googleApiKey: PropTypes.string.isRequired,
    apiToken: PropTypes.string.isRequired,
    apiEndpoint: PropTypes.string.isRequired,
  }

  picker = null

  componentDidMount() {
    this.props.closeActiveModal()
  }

  handlePickerCallback = data => {
    switch (data.action) {
      case window.google.picker.Action.PICKED:
        this.props.createInfoToasterMessage({
          title: 'Files import',
          detail: `Your data will begin importing shortly. You will be notified when we're done.`,
        })
        FilesApi.uploadGoogleDriveFiles(this.props, {
          input: {
            channelId: this.props.channel.id,
            fileList: data.docs.map(doc => {
              return {
                id: doc.id,
                creationSource: 'google_drive',
              }
            }),
          },
        })
        break
      case 'loaded':
      case window.google.picker.Action.CANCEL:
        break
      default:
        this.props.createErrorToasterMessage({
          title: 'An error occured while importing your data.',
          detail: 'Please try again or reach out to the support for help.',
        })
        break
    }
  }

  createPicker = () => {
    const { accessToken, googleApiKey, googleProjectId } = this.props

    // Scope to use to access user's Drive items.
    const view = new window.google.picker.View(window.google.picker.ViewId.DOCS)
    view.setMimeTypes(
      [
        'application/vnd.google-apps.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/msword',
        'text/plain',
        'text/markdown',
      ].join(',')
    )

    this.picker = new window.google.picker.PickerBuilder()
      .enableFeature(window.google.picker.Feature.NAV_HIDDEN)
      .enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
      .setAppId(googleProjectId)
      .setOAuthToken(accessToken)
      .addView(view)
      .addView(new window.google.picker.DocsUploadView())
      .setDeveloperKey(googleApiKey)
      .setCallback(this.handlePickerCallback)
      .setSize(600, 600)
      .hideTitleBar()
      .build()
    this.picker.setVisible(true)
  }

  render() {
    // Since React portal doesn't work to load scripts
    // Let's roll the vanilla way, 🍨
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://apis.google.com/js/api.js'
    script.addEventListener('load', () => {
      window.gapi.load('picker', { callback: this.createPicker })
    })
    document.body.appendChild(script)

    return null
  }
}

export default connect(
  function mapStateToProps(state) {
    return {
      apiToken: AuthSelectors.getApiToken(state),
      apiEndpoint: ConfigSelectors.getApiEndpoint(state),
      googleApiKey: ConfigSelectors.getGoogleApiKey(state),
      googleProjectId: ConfigSelectors.getGoogleProjectId(state),
    }
  },
  {
    closeActiveModal,
    createErrorToasterMessage,
    createInfoToasterMessage,
  }
)(ImportFromGoogleDrive)
